import { inject, Injectable } from '@angular/core';
import { MarketingSessionService } from './marketing-session.service';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class FacebookPixelService {
  private readonly marketingSessionService = inject(MarketingSessionService);
  /**
   * Track a standard Facebook Pixel event
   */
  trackEvent(eventName: string, params?: Record<string, unknown>): void {
    if (typeof window !== 'undefined' && window.fbq) {
      if (params) {
        window.fbq('track', eventName, params);
      } else {
        window.fbq('track', eventName);
      }

      console.log('[SEND FB EVENT]', eventName, params);
    }
  }

  /**
   * Track a custom Facebook Pixel event
   */
  trackCustomEvent(eventName: string, params?: Record<string, unknown>): void {
    if (typeof window !== 'undefined' && window.fbq) {
      if (params) {
        window.fbq('trackCustom', eventName, params);
      } else {
        window.fbq('trackCustom', eventName);
      }

      console.log('[SEND CUSTOM FB EVENT]', eventName, params);
    }
  }

  /**
   * Track wizard completion (Purchase event with $0 value)
   */
  trackWizardComplete(): void {
    const params = { currency: 'USD', value: 0 };
    this.trackEvent('Purchase', params);

    // Also track in marketing session for backend analytics
    this.marketingSessionService.trackEvent('Purchase', params);
  }
}

